import React from 'react'
import { Grid,Paper, List, ListItem, ListItemText, Typography, Divider, Button, Icon, Link } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CodeBase from './codeComponent';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';
import LinkButton from './LinkButton'

export default class GettingStarted extends React.Component{
    constructor(props){
        super(props);
        window.addEventListener('resize',this.update)
        this.state={
            update:false,
            open:false,
        }

        this.whatIsActumJsRef   = React.createRef();
        this.whyActumJsRef      = React.createRef();
        this.installationRef    = React.createRef();
        this.CoreConceptRef     = React.createRef();
        
    }
    toggleDrawer=()=>{
        this.setState({open:(!this.state.open)})
    }
    update=()=>{this.setState({update:(!this.state.update)});}
    mobileView=()=>{
        let list=this.renderSideMenu();
        let whatIsActumJs=this.whatIsActumJs();
        let whyActumjs=this.whyActumJs();
        let installation=this.installation();
        let CoreConcept=this.CoreConcept();
        return<>
            <div style={{padding:'10px',marginTop:'20px'}}>
                <div>
                    {list}
                </div>
                {whatIsActumJs}
                {whyActumjs}
                {installation}
                {CoreConcept}
            </div>
         </>
    }
    getListItem=()=>{
        return ["What is Actumjs","Why Actumjs?","Installation","Core Concepts"]
    }
    whatIsActumJs=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        return <div ref={this.whatIsActumJsRef}>
            <Typography variant='h4' className='textTitle' >What is Actumjs? </Typography>
            <Divider/>
            <Typography  className={className} >
                Actumjs is a Javascript library to manage application state.
                You can use Actumjs with front-end libraries and frameworks like Reactjs,Vue and Angular.
                <br/>
                it provides a state which is accessible to all other components of an application.
                <br/>The only way to to update the applicaiton state is to trigger an action.
                <br/>
                {/* Actum devtools extension allows to track the updates to store and time-travel debugging. */}
            </Typography>
        </div>
    }
    whyActumJs=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        return <div ref={this.whyActumJsRef}>
            <Typography variant='h4' className='textTitle'>Why Actumjs? </Typography>
            <Divider/>
            <Typography className={className}>
                    Managing applicaiton state is arguably the hardest part of any Javascript application development.
                    Specially when,communication between components is done in simplex manner(top to down).
                   
                    <br/>
                    There are so many state management libraries available and more coming
                    around every day. 
                    {/* One of the things that makes it so difficult is that we often
                    over-engineer our solution to the problem. */}
                    <br/>
                    While developing Javascript app with front-end frameworks and libs (Reactjs,Vue and Angular), the main problem is sharing application
                    state with other components.
                    <br/>we know react provides one
                    directional communication to its components(parent component pass its
                    state to child component in terms of props),this becomes harder when it comes
                    to write application having  large number of components.
                    that's why we have Actumjs.
            </Typography>
        </div>
    }
    installation=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        let consoleStyle=(window.screen.width<=768)?'consoleStyleMobile':'consoleStyle'
        return <div ref={this.installationRef}>
                    <Typography variant='h4' className='textTitle'>Installation</Typography>
                    <Divider/>
                    <Typography className={className}>
                    {/* Actumjs can be used with both node js and browser */}
                    <br/>
                    <b>Using NPM</b>
                    <CodeBase
                    lines={["npm install  @actumjs/actum"]}
                    lang='js'
                    />
                    <br/>
                    <b>Using Yarn</b>
                    <CodeBase
                    lines={[" yarn add @actumjs/actum"]}
                    lang='js'
                    />
                    <b>
                     With browser script tag
                    </b>
                    <CodeBase
                    lines={['<script type="text/Javascript" src="https://actumjs.github.io/dist/v1.0.0/actum.js"></script>']}
                    lang='html'
                    />
                    </Typography>
                </div>
    }
    CoreConcept=()=>{
        let className   =(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        let width       =(window.screen.width<=768)?'100%':'800px'

        return <div ref={this.CoreConceptRef} >
                    <Typography  className='textTitle' variant='h4' >Core Concept</Typography>
                    <Divider/>
                    <Typography className={className}>
                            Consider the traditional way to manage app state with Reactjs.
                            <br/>
                            We have components passing its state to child components using props.
                                <Grid container>
                                    <Grid item xs={12} sm={12} lg={6} md={6} >
                                        <img src="/images/simplex.png" 
                                        style={{
                                            width: '100%',
                                            height: '100%'
                                        }}
                                        />
                                    </Grid>
                                </Grid>
                            This is quite a simple way we can use with small web apps.
                            <br/>Now ,things goes
                            worst when it comes to make an app with  more components.
                            <br/>Passing data in this way dastrically become tadious.
                            <br/>
                            In this case we need to communicate with bidirectional way like this
                            <Grid container>
                                    <Grid item xs={12} sm={12} lg={8} md={8} >
                                        <img src="/images/duplex.png" 
                                        style={{
                                            width: '100%',
                                        }}
                                        />
                                    </Grid>
                                </Grid>
                            <br/>
                            Actumsjs provides communication between data and component in the
                            following way:
                            <br/>
                            <ul>
                                <li>
                                    A global object representing app state called store is created.
                                </li>
                                <li>
                                    Actions are added to store
                                </li>
                                <li>
                                     Actions update applicaiton state
                                </li>
                                <li>
                                    Component subscribe to store updates by using listeners
                                </li>
                                <li>
                                    Listeners provides way to response to store changes
                                </li>
                                <li>
                                    Store data is available to other components
                                </li>
                            </ul>
                            <Grid container>
                                    <Grid item xs={12} sm={12} lg={12} md={12} >
                                        <img src="/images/actum.png" style={{width: width}}/>
                                    </Grid>
                            </Grid>
                            Actumjs is based on following object and functions to implement state management mechanism
                                <ul>
                                    <li>
                                        <Typography variant='text' >Store</Typography>
                                    </li>
                                    <li>
                                        <Typography variant='text' >Actions</Typography>
                                   </li>
                                    <li>
                                        <Typography variant='text' >Listeners</Typography>
                                    </li>
                                </ul>
                            <br/>
                    </Typography>
                    <Grid container justify='space-between'>
                    <Grid item >
                            <Link href="/">
                                <ArrowLeft/>Home
                            </Link>
                        </Grid>
                        <Grid item >
                            <Link href="/api">
                                Api Reference
                                <ArrowRight/>
                            </Link>
                        </Grid>
                    </Grid>
                </div>        
    }
    scrollContent=(index)=>{
        let refs=[this.whatIsActumJsRef,this.whyActumJsRef,this.installationRef,this.CoreConceptRef];
        // [this.whatIsActumJsRef,this.whyActumJsRef,this.installationRef,this.CoreConceptRef]
        let curRef=refs[index];
        // console.log("ref",curRef,index,refs)
         let y=curRef.current.offsetTop-80;
         window.scrollTo(0,y);
         this.toggleDrawer();
    }
    renderSideMenu=()=>{
        let list=null
        let listContent=null;
        if(window.screen.width<=768){
            if(this.state.open){
                 list=this.getListItem();
                 listContent=<List style={{color: 'black',position: 'sticky',top: '74px',left: '0'}}>
                                    {
                                        list.map((item,index)=>{
                                            return <ListItem button alignItems="flex-start" onClick={()=>{this.scrollContent(index)}}>
                                                        <ListItemText  padding="56">{item}</ListItemText>
                                                    </ListItem>
                                            })
                                    }
                                <ListItem button alignItems="flex-start" onClick={this.toggleDrawer}>
                                    <ListItemText  padding="56">Close</ListItemText>
                                </ListItem>
                            </List>;
                return <div className="menuListContainer">
                    {listContent}
                </div>
            }else{
                return <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0
                }}>
                    <IconButton className="sideButtom" edge="start" color="inherit" aria-label="menu" onClick={this.toggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                </div>
            }
        }
         list=this.getListItem();
         listContent=null;
        listContent=<List style={{color: 'black',position: 'sticky',top: '74px',left: '0'}}>
                            {
                                list.map((item,index)=>{
                                    return <ListItem button alignItems="flex-start"  onClick={()=>{this.scrollContent(index)}} >
                                                <ListItemText  padding="56">{item}</ListItemText>
                                            </ListItem>
                                    })
                            }
                    </List>
        return listContent;
    }

    normalView=()=>{
        let list            = this.renderSideMenu();
        let whatIsActumJs   = this.whatIsActumJs();
        let whyActumjs      = this.whyActumJs();
        let installation    = this.installation();
        let CoreConcept     = this.CoreConcept();
    return<Grid container>
            <Grid md={2} lg={2}>
                {list}
            </Grid>
            <Grid md={10} lg={10}>
                <Paper style={{padding:'20px',margin:'20px',paddingLeft: '150px',paddingRight: '150px'}}>
                    {whatIsActumJs}
                    {whyActumjs}
                    {installation}
                    {CoreConcept}
                </Paper>
            </Grid>
        </Grid>
    }

    render(){
        let content=null;
        if(window.screen.width<=768){
            content=this.mobileView();
        }else{
            content=this.normalView();
        }
        return <div style={{marginTop:'70px',color:'white',marginBottom:"20px"}}>
            {content}
        </div>; 
    }
}